import Transformer from "@/utils/transformer"
import apiClient, { removeValuesWithObjectType } from "@/utils/cb-client"
import "@/utils/vendor-polyfills.js"
import BulkApi from "@/utils/bulk-api"
import BulkApiHelper from "@/utils/bulk-api-helper";

export default class PaynowSubmitter{

  constructor(state, getters) {
    this.state = state;
    this.getters = getters;
    this.bulkApiRequest = new BulkApi()
    BulkApiHelper.setConfig(state, getters)
  }

  handleCollectNow(payload) {
    if(payload.override_billing_profile) {
        return this.collectNowWithOverrideBillingProfile(payload);
    }
    return this.collectNow(payload);
  }

  collectNow(payload) {
    return apiClient.customers.collect_payment(
        { 
            id: this.state.auth.customer_handle, 
            hp_token: this.state.auth.hpToken 
        }, 
        this.getTransformedPayload(payload)
    );
  }

  overrideBillingProfile(subId, paymentSourceId) {
    return apiClient.subscriptions.override_billing_profile({ id: subId }, { payment_source_id: paymentSourceId });
  }

  collectNowWithOverrideBillingProfile(payload) {
    let collectNowResponse;
    return this.collectNow(payload)
    .then((resp) => {
      collectNowResponse = resp;
      if(!resp || !resp.transactions || !this.getters.selected_invoices) {
        return resp
      }
      const sub = this.getters.selected_invoices.filter(inv => inv.subscription_id)[0];
      const transaction = resp.transactions.filter(trans => trans.payment_source_id)[0];
      if(!sub || !transaction) {
        return resp
      }
      return this.overrideBillingProfile(sub.subscription_id, transaction.payment_source_id);
    }).then(() => {
      return collectNowResponse;
    })
  }

  getTransformedPayload({paymentData, replace_primary_payment_source, retain_payment_source}) {
    return Transformer.collectPaymentNewSource(
        {state: this.state, getters: this.getters}, 
        paymentData, 
        {
            replace_primary_payment_source,
            retain_payment_source,
        }
    )
  }

}
